import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Subtract } from '../../../assets/images/web-isn';
import { getPathLanguage } from '../../../utils/params';

function BreadcrumbServicedOfficeComponent() {
  const { t } = useTranslation();
  const location = useLocation();
  const pathLanguage = getPathLanguage(location);
  // const getHref = window.location.href;

  let textBreadcrumb = '';
  if (location.pathname.includes('/serviced-office/overview')) {
    // textBreadcrumb = t('');
    textBreadcrumb = (
      <li className="d-flex align-items-center child-active mr-3">{t('servicedOffice.label_overview')}</li>
    );
  } else if (location.pathname.includes('/serviced-office/types/private-room')) {
    textBreadcrumb = (
      <>
        <li className="d-flex align-items-center child-active mr-3">{t('servicedOffice.label_privateRoom')}</li>
      </>
    );
  } else if (location.pathname.includes('/serviced-office/types/work-space')) {
    textBreadcrumb = (
      <>
        <li className="d-flex align-items-center child-active mr-3">{t('servicedOffice.label_workSpace')}</li>
      </>
    );
  } else if (location.pathname.includes('/serviced-office/types/virtual-offices')) {
    textBreadcrumb = (
      <>
        <li className="d-flex align-items-center child-active mr-3">{t('servicedOffice.label_virtualOffices')}</li>
      </>
    );
  } else if (location.pathname.includes('/serviced-office/types/meeting-room')) {
    textBreadcrumb = (
      <>
        <li className="d-flex align-items-center child-active mr-3">{t('servicedOffice.label_meetingRoom')}</li>
      </>
    );
  } else if (location.pathname.includes('/serviced-office/location')) {
    textBreadcrumb = (
      <>
        <li className="d-flex align-items-center child-active mr-3">{t('servicedOffice.label_location')}</li>
      </>
    );
  } else if (location.pathname.includes('/serviced-office/gallery')) {
    textBreadcrumb = (
      <>
        <li className="d-flex align-items-center child-active mr-3">{t('servicedOffice.label_gallery')}</li>
      </>
    );
  }

  return (
    <div id="breadcrumbApartmentMenu">
      <div className="container">
        <div className="apartment-breadcrumb">
          <ul className="d-flex align-items-center">
            <li className="d-flex align-items-center mr-3">
              <Link className="first-item mr-3" to={pathLanguage}>
                {t('servicedOffice.label_home')}
              </Link>
              <img src={Subtract} alt="subtract" />
            </li>
            <li className="d-flex align-items-center mr-3">
              {!location.pathname.includes('/serviced-office/overview') ? (
                <Link className="child-item mr-3" to={`${pathLanguage}/serviced-office/overview`}>
                  {t('servicedOffice.label_servicedOffice')}
                </Link>
              ) : (
                <span className="child-item-no-link mr-3">{t('servicedOffice.label_servicedOffice')}</span>
              )}
              <img src={Subtract} alt="subtract" />
            </li>
            {/* {location.pathname.includes('/serviced-office/overview') ? (
              <li className="d-flex align-items-center child-active mr-3">{localStorage.getItem('apartmentName')}</li>
            ) : (
              ''
            )} */}

            {textBreadcrumb}
          </ul>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbServicedOfficeComponent);
